import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";

const BASE_URL = process.env.REACT_APP_DATA_FEEDER;

const DatabaseViewReport = () => {
  const [comparisonReport, SetComparisonReport] = useState([]);

  const [pageToday, setPageToday] = useState(1);
  const [pageLastSeven, setPageLastSeven] = useState(1);
  const [pageLatest, setPageLatest] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const token = sessionStorage.getItem("jwtToken");
  const xApiKey = sessionStorage.getItem("xApiKey");

  const fallbackData = {};

  const fallbackTodayData = [
    //   {
    //       "dbReportTableName": "Valuation Table",
    //       "databaseViewReports": {
    //           "SymbolValuationData": [
    //               {
    //                   "uatRows": 1473,
    //                   "prodRows": 0,
    //                   "sourcedDate": null,
    //                   "monthYear": "Mar2026"
    //               },
    //               {
    //                   "uatRows": 1472,
    //                   "prodRows": 1473,
    //                   "sourcedDate": null,
    //                   "monthYear": "Feb2026"
    //               },
    //               {
    //                   "uatRows": 1475,
    //                   "prodRows": 1475,
    //                   "sourcedDate": null,
    //                   "monthYear": "Jan2026"
    //               }
    //           ]
    //       }
    //   },
    //   {
    //       "dbReportTableName": "Quarterly Tables",
    //       "databaseViewReports": {
    //           "SymbolFinancialDataQuarterly": [
    //               {
    //                   "uatRows": 1455,
    //                   "prodRows": 1448,
    //                   "sourcedDate": "2025-12-31",
    //                   "monthYear": "Dec2025"
    //               },
    //               {
    //                   "uatRows": 1473,
    //                   "prodRows": 1468,
    //                   "sourcedDate": "2025-09-30",
    //                   "monthYear": "Sep2025"
    //               },
    //               {
    //                   "uatRows": 1463,
    //                   "prodRows": 1465,
    //                   "sourcedDate": "2025-06-30",
    //                   "monthYear": "Jun2025"
    //               }
    //           ],
    //           "stockkeymetricsdataquarterly": [
    //               {
    //                   "uatRows": 1480,
    //                   "prodRows": 1474,
    //                   "sourcedDate": "2025-12-31",
    //                   "monthYear": "Dec2025"
    //               },
    //               {
    //                   "uatRows": 1491,
    //                   "prodRows": 1488,
    //                   "sourcedDate": "2025-09-30",
    //                   "monthYear": "Sep2025"
    //               },
    //               {
    //                   "uatRows": 1464,
    //                   "prodRows": 1466,
    //                   "sourcedDate": "2025-06-30",
    //                   "monthYear": "Jun2025"
    //               }
    //           ]
    // }
    //   }
  ];

  const refreshDBData = () => {
    fetch(`${BASE_URL}/data/refreshDBComparisonView`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
    })
      .then(() => {
        // After refresh, fetch latest data again
        return fetch(`${BASE_URL}/data/databaseViewReports`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-API-KEY": xApiKey,
          },
        });
      })
      .then((res) => res.json())
      .then((data) => SetComparisonReport(flattenGroupedData(data)))
      .catch(() => alert("Refresh failed"));
  };

  useEffect(() => {
    fetch(`${BASE_URL}/data/databaseViewReports`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
    })
      .then((res) => res.json())
      .then((data) => SetComparisonReport(flattenGroupedData(data)))
      .catch(() => SetComparisonReport(flattenGroupedData(fallbackTodayData)));
  }, []);

  const renderPagination = (data, currentPage, setPage) => {
    const totalPages = Math.ceil(data.length / rowsPerPage);

    if (totalPages <= 1) return null;

    return (
      <nav className="mt-3">
        <ul className="pagination justify-content-center">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => setPage(currentPage - 1)}
            >
              Previous
            </button>
          </li>

          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => setPage(index + 1)}>
                {index + 1}
              </button>
            </li>
          ))}

          <li
            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => setPage(currentPage + 1)}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const flattenGroupedData = (data) => {
    const result = [];

    (data || []).forEach((mainTable) => {
      // Main group name
      result.push({
        isGroup: true,
        groupName: mainTable.dbReportTableName,
        groupType: "main",
      });

      const reports = mainTable.databaseViewReports || {};

      Object.keys(reports).forEach((tableName) => {
        // Sub table name row
        result.push({
          isGroup: true,
          groupName: tableName,
          groupType: "sub",
        });
        reports[tableName].forEach((row) => {
          result.push({
            ...row,
            isGroup: false,
          });
        });
      });
    });

    return result;
  };

  const renderTable = (title, data, currentPage, setPage) => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + rowsPerPage);

    return (
      <div className="container-fluid mb-5">
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary btn-sm" onClick={refreshDBData}>
            Refresh Data
          </button>
        </div>
        <h3 className="fw-bold text-center mb-3">{title}</h3>

        <div className="table-responsive" style={{ marginBottom: "200px" }}>
          <table className="table table-bordered  align-middle">
            <thead className="table-light">
              <tr>
                <th>ID</th>
                <th>Uat Rows</th>
                <th>Prod Rows</th>
                <th>Sourced Date</th>
                <th>Month Year</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((item, index) => {
                if (item.isGroup) {
                  const rowClass =
                    item.groupType === "main"
                      ? "table-secondary text-white fw-bold"
                      : "table-light";

                  return (
                    <tr key={index} className={rowClass}>
                      <td
                        colSpan="5"
                        style={{
                          paddingLeft:
                            item.groupType === "sub" ? "30px" : "10px",
                          fontSize: item.groupType === "main" ? "18px" : "17px",
                        }}
                      >
                        {item.groupName}
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr key={index}>
                    <td>{startIndex + index + 1}</td>
                    <td>{item.uatRows}</td>
                    <td>{item.prodRows}</td>
                    <td>{item.sourcedDate}</td>
                    <td>{item.monthYear}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <nav className="d-flex justify-content-center mt-3">
            {renderPagination(data, currentPage, setPage)}
            <div
              className="justify-content-between align-items-center mt-3"
              style={{ paddingLeft: "50px" }}
            >
              <span className="me-2">Show</span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setPage(1);
                }}
                className="form-select d-inline-block"
                style={{ width: "80px" }}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <span className="ms-2">entries</span>
            </div>
          </nav>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />

      <div className="main-content" style={{ paddingTop: "50px" }}>
        {renderTable(
          "Data Source Status UAT vs PROD",
          comparisonReport,
          pageLastSeven,
          setPageLastSeven,
        )}
      </div>

      <Footer />
    </>
  );
};

export default DatabaseViewReport;
